// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICipStatusSummaryRecordDto
 */
export interface ICipStatusSummaryRecordDto {
    /**
     * 
     * @type {number}
     * @memberof ICipStatusSummaryRecordDto
     */
    num_pending?: number;
    /**
     * 
     * @type {number}
     * @memberof ICipStatusSummaryRecordDto
     */
    num_passed?: number;
    /**
     * 
     * @type {number}
     * @memberof ICipStatusSummaryRecordDto
     */
    num_failed?: number;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusSummaryRecordDto
     */
    percent_passed?: string;
}

/**
 * Check if a given object implements the ICipStatusSummaryRecordDto interface.
 */
export function instanceOfICipStatusSummaryRecordDto(value: object): value is ICipStatusSummaryRecordDto {
    return true;
}

export function ICipStatusSummaryRecordDtoFromJSON(json: any): ICipStatusSummaryRecordDto {
    return ICipStatusSummaryRecordDtoFromJSONTyped(json, false);
}

export function ICipStatusSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICipStatusSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'num_pending': json['num_pending'] == null ? undefined : json['num_pending'],
        'num_passed': json['num_passed'] == null ? undefined : json['num_passed'],
        'num_failed': json['num_failed'] == null ? undefined : json['num_failed'],
        'percent_passed': json['percent_passed'] == null ? undefined : json['percent_passed'],
    };
}

export function ICipStatusSummaryRecordDtoToJSON(json: any): ICipStatusSummaryRecordDto {
    return ICipStatusSummaryRecordDtoToJSONTyped(json, false);
}

export function ICipStatusSummaryRecordDtoToJSONTyped(value?: ICipStatusSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'num_pending': value['num_pending'],
        'num_passed': value['num_passed'],
        'num_failed': value['num_failed'],
        'percent_passed': value['percent_passed'],
    };
}

